function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
import { QueryCombinerType } from 'api/tasks/filter-types';
import { fieldAccessMetaToBase3 } from 'utils/field-access';
import { constructUrl } from 'utils/http-utilts';
import { getSimpleSearchFilterModule } from 'utils/simple-search-filter/module';
class SprintPlanningHttpClient extends HttpClient {
    async getSprintConfiguration() {
        return this.get('/sprint-planning/configuration');
    }
    async updateConfig(newConfig) {
        return this.put('/sprint-planning/configuration', newConfig);
    }
    async createSprint(payload) {
        return this.post('/sprints', payload);
    }
    async getSprint(sprintId) {
        return this.get(`/sprints/${sprintId}`);
    }
    async getTaskCountInSprint(sprintId) {
        return this.get(`/tasks/get-tasks-with-current-sprint/${sprintId}`);
    }
    async updateSprint(sprintId, payload, isSync) {
        return this.put(`/sprints/${sprintId}${isSync ? `?isSync=${true}` : ''}`, payload);
    }
    async addTasksToSprint(sprintId, payload) {
        return this.post(`/sprints/${sprintId}/add-tasks`, {
            taskIds: payload
        });
    }
    async getSprintsList({ startDate, endDate, projectIds, inComplete, isAlreadyAddedToPhase = true, sprintId }) {
        const url = constructUrl({
            baseURL: 'sprints/get-sprints/light/',
            params: {
                sprintId,
                inComplete,
                projectIds,
                startDate: !inComplete ? startDate : undefined,
                endDate: !inComplete ? endDate : undefined,
                isAlreadyAddedToPhase: !isAlreadyAddedToPhase ? isAlreadyAddedToPhase : undefined
            }
        });
        return this.get(`${url}`);
    }
    async updateSprintStatus({ sprintId, payload }) {
        return this.put(`/sprints/${sprintId}`, payload);
    }
    async removeTaskFromSprint({ sprintId, payload }) {
        return this.post(`/sprints/${sprintId}/remove-task`, payload);
    }
    async getTasksInSprintForExternalUser({ sprintId, projectId }) {
        return this.get(`projects/${projectId}/sprints/${sprintId}/tasks`);
    }
    async deleteSprint({ sprintId }) {
        return this.delete(`/sprints/${sprintId}`);
    }
    async completeSprint({ sprintId, payload }) {
        return this.post(`/sprints/${sprintId}/complete-sprint`, payload);
    }
    async sprintsCount() {
        return this.get('/sprints/total-count');
    }
    async getEpicsList() {
        const data = await this.get('/epics?epic*isArchived.value=false');
        return data.data;
    }
    async getEpicsListWithGroupBy(epicId, groupBy, filter, search) {
        const { ApiGroupFilter } = await getSimpleSearchFilterModule();
        const filterAsString = ApiGroupFilter.toQueryStringFormatForGroups(filter.criteria);
        const validFilterType = Object.values(QueryCombinerType).includes(filter.type) ? filter.type : QueryCombinerType.All;
        const filterString = filter.criteria.length ? filterAsString : undefined;
        const url = constructUrl({
            baseURL: `/epics/${epicId}/tasks/group`,
            params: {
                groupBy,
                match: validFilterType
            },
            paramsToAddWithoutKeys: [
                filterString,
                search
            ]
        });
        return this.get(url);
    }
    async createEpic(payload) {
        return this.post('/epics', payload);
    }
    async getEpic(epicId) {
        return this.get(`/epics/${epicId}`);
    }
    async updateEpic(epicId, payload) {
        return this.put(`/epics/${epicId}`, payload);
    }
    async deleteEpic(epicId) {
        return this.delete(`/epics/${epicId}`);
    }
    async archiveEpic(epicId) {
        return this.put(`/epics/${epicId}/archive-epic`);
    }
    async unarchiveEpic(epicId) {
        return this.put(`/epics/${epicId}/unarchive-epic`);
    }
    async addTasksToEpic(epicId, taskIds) {
        return this.post(`/epics/${epicId}/add-tasks`, {
            taskIds
        });
    }
    async removeTaskFromEpic({ epicId, payload }) {
        return this.post(`/epics/${epicId}/remove-tasks`, payload);
    }
    async getEpicsCount() {
        return this.get('/epics/total-count');
    }
    async getEpicsForAccount() {
        return this.get('/epics/epicsLight');
    }
    // Backlog methods
    async getBacklogsCount() {
        return this.get('/backlogs/total-count');
    }
    async createBacklog(payload) {
        return this.post('/backlogs', payload);
    }
    async updateBacklog(backlogId, payload) {
        return this.put(`/backlogs/${backlogId}`, payload);
    }
    async getBacklog(backlogId) {
        return this.get(`/backlogs/${backlogId}`);
    }
    async getBacklogTasks({ backlogId, startRow, endRow, filter, filterType, sort, searchValue }) {
        const { ApiGroupFilter } = await getSimpleSearchFilterModule();
        const filterAsString = ApiGroupFilter.toQueryStringFormatForGroups(filter);
        const validFilterType = Object.values(QueryCombinerType).includes(filterType) ? filterType : QueryCombinerType.All;
        const url = constructUrl({
            baseURL: `/backlogs/${backlogId}/tasks`,
            params: {
                sort,
                offset: startRow,
                limit: endRow - startRow,
                match: validFilterType
            },
            paramsToAddWithoutKeys: [
                searchValue,
                filterAsString
            ]
        });
        return this.get(url).then((response)=>({
                ...response,
                data: response.data.map((task)=>task.fieldsAccessMeta != null ? {
                        ...task,
                        fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                    } : task)
            }));
    }
    async postBacklogTasks({ backlogId, startRow, endRow, filter, // filterType,
    sort, searchValue }) {
        let url = `/backlogs/${backlogId}/tasks?`;
        if (searchValue) {
            url += `${searchValue}&`;
        }
        if (sort) {
            url += `sort=${sort}`;
        }
        url += `&offset=${startRow}&limit=${endRow - startRow}`;
        return this.post(url, {
            filter
        }).then((response)=>({
                ...response,
                data: response.data.map((task)=>task.fieldsAccessMeta != null ? {
                        ...task,
                        fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                    } : task)
            }));
    }
    async getBacklogSprintTasks({ backlogId, sprintId, startRow, filterType, endRow, filter, sort, searchValue }) {
        const { ApiGroupFilter } = await getSimpleSearchFilterModule();
        const filterAsString = ApiGroupFilter.toQueryStringFormatForGroups(filter);
        const validFilterType = Object.values(QueryCombinerType).includes(filterType) ? filterType : QueryCombinerType.All;
        const url = constructUrl({
            baseURL: `/backlogs/${backlogId}/get-sprint-tasks/${sprintId}`,
            params: {
                sort,
                offset: startRow,
                limit: endRow - startRow,
                match: validFilterType
            },
            paramsToAddWithoutKeys: [
                searchValue,
                filterAsString
            ]
        });
        return this.get(url).then((response)=>({
                ...response,
                data: response.data.map((task)=>task.fieldsAccessMeta != null ? {
                        ...task,
                        fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                    } : task)
            }));
    }
    async removeSprintFromBacklog({ sprintId, backlogId }) {
        return this.delete(`/backlogs/${backlogId}/sprint/${sprintId}`);
    }
    async getBacklogSprints(backlogId) {
        return this.get(`/backlogs/${backlogId}/sprints`);
    }
    async addSprintToBacklog(backlogId, sprintIds) {
        return this.post(`/backlogs/${backlogId}/sprints`, sprintIds);
    }
    async archiveBacklog(backlogId) {
        return this.put(`/backlogs/${backlogId}/archive`);
    }
    async unarchiveBacklog(backlogId) {
        return this.put(`/backlogs/${backlogId}/unarchive`);
    }
    async deleteBacklog({ backlogId }) {
        return this.delete(`/backlogs/${backlogId}`);
    }
    async getBacklogSprintList(backlogId) {
        return this.get(`/backlogs/${backlogId}/available-sprints`);
    }
    async addTasksToSprintFromBacklog(backlogId, sprintId, payload) {
        return this.post(`/backlogs/${backlogId}/tasks-to-sprint/${sprintId}`, payload);
    }
    async reorderBacklogTasks(backlogId, beforeTaskId, taskIds) {
        return this.put(`/backlogs/${backlogId}/tasks-order?beforeTaskId=${beforeTaskId || 0}`, taskIds);
    }
    async checkTaskMovability(fromSourceType, fromSourceId, toSourceType, toSourceId, taskIds) {
        return this.post('/backlogs/check-task-movability', {
            fromSourceType,
            fromSourceId,
            toSourceType,
            toSourceId,
            taskIds
        });
    }
    async reorderSprintLevelTasks(sprintId, beforeTaskId, taskIds) {
        return this.put(`/backlogs/sprints/${sprintId}/tasks-order?beforeTaskId=${beforeTaskId || 0}`, taskIds);
    }
    async moveSprintTasksToBacklogs(backlogId, sprintId, beforeTaskId, taskIds, extendScope) {
        return this.post(`/backlogs/${backlogId}/move-tasks-from-sprint`, {
            fromEntityType: 'SPRINT',
            fromEntityId: sprintId,
            taskIds,
            beforeTaskId: beforeTaskId || 0,
            extendScope: extendScope || false
        });
    }
    async moveBacklogTasksToSprint(backlogId, sprintId, beforeTaskId, taskIds, extendScope) {
        return this.post(`/backlogs/sprints/${sprintId}/tasks/move-from-backlog`, {
            fromEntityType: 'BACKLOG',
            fromEntityId: backlogId,
            taskIds,
            beforeTaskId: beforeTaskId || 0,
            extendScope: extendScope || false
        });
    }
    async moveTasksBetweenSprints(fromSprintId, toSprintId, beforeTaskId, taskIds, extendScope) {
        return this.post(`/backlogs/${toSprintId}/tasks/move-from-sprint`, {
            fromEntityType: 'SPRINT',
            fromEntityId: fromSprintId,
            taskIds,
            beforeTaskId: beforeTaskId || 0,
            extendScope: extendScope || false
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "getPaginatedSprintList", async ({ startRow, endRow, filter, sort, search, startDate, endDate })=>{
            var _filter_criteria;
            const { ApiFilter } = await getSimpleSearchFilterModule();
            const filterAsString = (filter === null || filter === void 0 ? void 0 : (_filter_criteria = filter.criteria) === null || _filter_criteria === void 0 ? void 0 : _filter_criteria.length) ? ApiFilter.toQueryStringFormat(filter.criteria) : undefined;
            const url = constructUrl({
                baseURL: '/sprints',
                params: {
                    startDate,
                    endDate,
                    sort,
                    offset: startRow,
                    limit: endRow - startRow,
                    match: filter.type
                },
                paramsToAddWithoutKeys: [
                    search,
                    filterAsString
                ]
            });
            return this.get(url).then((response)=>response);
        }), _define_property(this, "getTaskStatusesWithCount", async (sprintId)=>{
            return this.get(`sprints/${sprintId}/get-task-statuses`);
        }), // Epic methods
        _define_property(this, "getPaginatedEpicList", async ({ startRow, endRow, filter, sort, search, dateRange })=>{
            var _filter_criteria;
            const { ApiFilter } = await getSimpleSearchFilterModule();
            const filterAsString = (filter === null || filter === void 0 ? void 0 : (_filter_criteria = filter.criteria) === null || _filter_criteria === void 0 ? void 0 : _filter_criteria.length) ? ApiFilter.toQueryStringFormat(filter.criteria) : undefined;
            const url = constructUrl({
                baseURL: '/epics',
                params: {
                    ...dateRange,
                    sort,
                    offset: startRow,
                    limit: endRow - startRow,
                    match: filter.type
                },
                paramsToAddWithoutKeys: [
                    search,
                    filterAsString
                ]
            });
            return this.get(url).then((response)=>response);
        }), _define_property(this, "getPaginatedBacklogsList", async ({ startRow, endRow, filter, sort, search, dateRange })=>{
            var _filter_criteria;
            const { ApiFilter } = await getSimpleSearchFilterModule();
            const filterAsString = (filter === null || filter === void 0 ? void 0 : (_filter_criteria = filter.criteria) === null || _filter_criteria === void 0 ? void 0 : _filter_criteria.length) ? ApiFilter.toQueryStringFormat(filter.criteria) : undefined;
            const url = constructUrl({
                baseURL: '/backlogs/light',
                params: {
                    ...dateRange,
                    sort,
                    offset: startRow,
                    limit: endRow - startRow,
                    match: filter.type
                },
                paramsToAddWithoutKeys: [
                    search,
                    filterAsString
                ]
            });
            return this.get(url).then((response)=>response);
        }), _define_property(this, "rearrangePhasesAndSprints", (payload)=>{
            return this.put(`/projects/${payload.projectId}/rearrange-phases-and-sprints`, payload);
        });
    }
}
export const SprintPlanningAPI = new SprintPlanningHttpClient();
